/* Fabryk Design — logo meekleuren met de navigatietekst (wit op transparante header, zwart op lichte header/mega/collectie/product) */
(function () {
  if (window.__fdLogoFix) return;
  window.__fdLogoFix = true;
  function visibleNav() {
    var links = document.querySelectorAll('.header__menu-item, .header__menu a, .header__inline-menu a');
    for (var i = 0; i < links.length; i++) { if (links[i].offsetParent !== null) return links[i]; }
    return links[0] || null;
  }
  function update() {
    var nav = visibleNav();
    var logos = document.querySelectorAll('.header__heading-logo');
    if (!nav || !logos.length) return;
    var m = getComputedStyle(nav).color.match(/\d+/g);
    if (!m) return;
    var lum = m[0] * 0.299 + m[1] * 0.587 + m[2] * 0.114;
    var val = lum < 140 ? 'brightness(0)' : '';
    for (var i = 0; i < logos.length; i++) {
      if (logos[i].style.filter !== val) logos[i].style.filter = val;
    }
  }
  document.addEventListener('DOMContentLoaded', update);
  window.addEventListener('load', update);
  ['scroll', 'mouseover', 'mouseout'].forEach(function (e) { window.addEventListener(e, update, true); });
  document.addEventListener('shopify:section:load', update);
  setInterval(update, 350);
  update();
})();
